module.exports = __webpack_public_path__ + "img/about.9a2ee5fe.png";